import { d as concatAll, m as map, j as first } from '../../../Either-48abb652.js';
import { p as pipe, a as identity } from '../../../ReadonlyNonEmptyArray-0e481d0b.js';
import { g as getMonoid } from '../../../Record-7477f278.js';
import { b as bimap } from '../../../Tuple-2f69c1c7.js';
import { f as firstRight } from '../../../fp-utils-24a5cc96.js';
import { isBoolValue, isNumberValue, isStringValue, isNullValue, isArrayValue, isStructValue } from '../struct-refined-types.js';
import '../../../ReadonlyRecord-86a56753.js';
import '../../../string-40bcd6bf.js';
import 'lodash';
import 'ricos-schema';

const mergeJsonMap = getMonoid(first());
const toRecord = ([k, v]) => ({ [k]: v });
const convertStructToJson = (message) => pipe(
  message.fields,
  Object.entries,
  map(bimap(convertValueToJson, identity)),
  map(toRecord),
  concatAll(mergeJsonMap)
);
const convertValueToJson = (message) => firstRight(message, null, [
  [isBoolValue, ({ boolValue }) => boolValue],
  [isNumberValue, ({ numberValue }) => numberValue],
  [isStringValue, ({ stringValue }) => stringValue],
  [isNullValue, () => null],
  [isArrayValue, (m) => convertListToJson(m.listValue || { values: [] })],
  [isStructValue, (m) => convertStructToJson(m.structValue || { fields: {} })]
]);
const convertListToJson = (message) => pipe(message.values, map(convertValueToJson));

export { convertStructToJson };
//# sourceMappingURL=convertStructToJson.js.map
